import {
  type KnowledgeQueries,
  defKnowledgeQueries,
} from '@kizen/query/knowledge';

import AxiosService from 'services/AxiosService';

const queries: KnowledgeQueries = defKnowledgeQueries(AxiosService);

export const knowledgeSourceSearchQuery: KnowledgeQueries['knowledgeSourceSearchQuery'] =
  queries.knowledgeSourceSearchQuery;

export const onlineSourceSearchQuery: KnowledgeQueries['onlineSourceSearchQuery'] =
  queries.onlineSourceSearchQuery;

export const onlineSourcePagesSearchQuery: KnowledgeQueries['onlineSourcePagesSearchQuery'] =
  queries.onlineSourcePagesSearchQuery;

export const knowledgeCatalogListQuery: KnowledgeQueries['knowledgeCatalogListQuery'] =
  queries.knowledgeCatalogListQuery;

export const knowledgeCatalogQuery: KnowledgeQueries['knowledgeCatalogQuery'] =
  queries.knowledgeCatalogQuery;
